import React, { memo, forwardRef } from "react";
const SvgCapitalF = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M13.86 21.75c0 .307-.047.553-.14.74a1.344 1.344 0 01-.34.42.814.814 0 01-.4.2c-.147.04-.274.06-.38.06-.107 0-.233-.02-.38-.06a.94.94 0 01-.42-.2 1.518 1.518 0 01-.32-.42c-.094-.187-.14-.433-.14-.74V10.33c0-1 .5-1.5 1.5-1.5h6.58c.266 0 .48.04.64.12.173.08.3.18.38.3.093.12.153.247.18.38.026.12.04.22.04.3 0 .08-.014.187-.04.32a.912.912 0 01-.18.36.887.887 0 01-.38.3c-.16.08-.373.12-.64.12h-5.56v3.88h5.22c.267 0 .48.04.64.12.16.08.28.18.36.3.08.107.133.22.16.34.027.12.04.22.04.3 0 .08-.014.18-.04.3-.027.12-.08.24-.16.36-.08.107-.2.2-.36.28-.16.08-.373.12-.64.12h-5.22v4.72z"
      />
    </svg>
  );
});
SvgCapitalF.displayName = "SvgCapitalF";
const MemoForwardRef = memo(SvgCapitalF);
export default MemoForwardRef;
